import { Component, OnInit } from '@angular/core';
import { QuestionnaireService } from '../services/questionnaire.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LiabilitiesArrayComponent } from '../liabilities-array/liabilities-array.component';
import { ValidateDate } from '../date-validator';

@Component({
	selector: 'app-liabilities',
	templateUrl: './liabilities.component.html',
	styleUrls: ['./liabilities.component.scss']
})
export class LiabilitiesComponent implements OnInit {
	private route$: Subscription;
	qID: any;
	prevQID: any;
	//liabilities = [];
	//liabilitiesNumber: number = 1;
	//liabilitiesIndex: number = 0;
	//question 1
	visibleQids;
	editQuestion;
	currentStep;
	liabilitiesForm: FormGroup;
	submitted;

	window = window;

	qFields = {
		1: [{ name: "haveYouLiabilities", validators: [Validators.required] }],
		2: [{ name: "liabilitiesArray"}]
	};

	qArrFields = {
		2: [
			{ name: "liabilityType", validators: [Validators.required] },
			{ name: "liabilityBalance", validators: [Validators.required]},
			{ name: "liabilityMonthlyRefund", validators: [Validators.required]}
		]
	};

	constructor(
		private questionnaireService: QuestionnaireService,
		private activeRoute: ActivatedRoute,
		private router: Router,
		private fb: FormBuilder
	) { }

	ngOnInit() {
		this.createForm();

		this.route$ = this.activeRoute.params.subscribe(params => {
			console.log("-----------------------------> params", params);
			this.prevQID = this.qID;
			this.qID = params.qid;
			this.editQuestion = null;

			if (params.qid === "all") {
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
			} else {
				this.setValidators();
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
			}
		});
	}

	createForm() {
		this.currentStep = this.questionnaireService.getStep("liabilities");

		this.liabilitiesForm = this.fb.group({
			haveYouLiabilities: this.questionnaireService.getQuestion(this.currentStep, "1").selectedAnswer,//problem with button
			liabilitiesArray: LiabilitiesArrayComponent.buildLiabilities(this.questionnaireService.getQuestion(this.currentStep, "2").answer.fieldsArray)
		});
	}

	setValidators() {
		this.questionnaireService.clearAllQuestionValidators(this.liabilitiesForm.controls, this.qFields, this.qArrFields);
		this.questionnaireService.setCurrentQuestionValidators(this.qID, this.liabilitiesForm.controls, this.qFields, "5", this.qArrFields);

		this.submitted = false;
	}

	nextClick(qID, answers) {
		if (answers) {
			this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
		}
	}

	onSubmit({ value, valid }: { value: any, valid: boolean }) {
		console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>  onSubmit(): valid=", valid, "value", value);
		this.submitted = true;

		if (valid) {
			let q;
			let submitQID = (this.qID !== "all") ? this.qID : this.editQuestion;

			q = this.qFields[submitQID];

			value = this.liabilitiesForm.getRawValue();

			let values = q.map(r => {
				return value[r.name];
			});
			this.questionnaireService.sendGA(this.currentStep,this.qID, values);
			this.nextClick(submitQID, values);
		}

		window["logInvalidControls"](this.liabilitiesForm);
	}

	editQuestionChange(qid){
		this.qID = qid;
		this.setValidators();
	}
}



// WEBPACK FOOTER //
// ./src/app/liabilities/liabilities.component.ts